/* eslint-disable array-callback-return */
/* eslint-disable linebreak-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/display-name */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useAmp } from 'next/amp';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Container from 'base-ui/dist/Container';
import PageWrapper from 'base-ui/dist/PageWrapper';
import Heading from 'base-ui/dist/Heading';
import isBrowser from 'utils/isBrowser';
import { Sentry } from 'root/utils/raven';
import getSiteDomain from 'utils/getSiteDomain';
import get from 'base-ui/dist/underline/get';
import PostCardAdInfo from 'components/PostCardAdInfo';

const getConfig = require('next/config').default;

const RenderHtmlReactLoading = dynamic(
  () => import('utils/RenderHtmlReact/Loading'));
const BreadcrumbsLoading = dynamic(
  () => import('components/Breadcrumbs/Loading'));
const PostMetasLoading = dynamic(() => import('components/PostMetas/Loading'));
const AuthorSignedCardLoading = dynamic(
  () => import('components/AuthorSignedCard/Loading'));
const PostRelatedLinksLoading = dynamic(
  () => import('components/PostRelatedLinks/Loading'));
const PostBibliographyLoading = dynamic(
  () => import('components/PostBibliography/Loading'));
const SponsorBoxLoading = dynamic(
  () => import('components/SponsorBox/Loading'));
const AuthorBoxLoading = dynamic(() => import('components/AuthorBox/Loading'));
const ShareButtonsLoading = dynamic(
  () => import('components/ShareButtons/Loading'));

const RenderHtmlReact = dynamic(
  () => import('utils/RenderHtmlReact'),
  {
    loading: () => (
      <RenderHtmlReactLoading
        mobile={{
          width: '480',
          height: '300',
        }}
        desktop={{
          width: '618',
          height: '500',
        }}
      />
    ),
  });
const Breadcrumbs = dynamic(
  () => import('components/Breadcrumbs'),
  {
    loading: () => (
      <BreadcrumbsLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const PostMetas = dynamic(
  () => import('components/PostMetas'),
  {
    loading: () => (
      <PostMetasLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const AuthorSignedCard = dynamic(
  () => import('components/AuthorSignedCard'),
  {
    loading: () => (
      <AuthorSignedCardLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });
const PostRelatedLinks = dynamic(
  () => import('components/PostRelatedLinks'),
  {
    loading: () => (
      <PostRelatedLinksLoading
        mobile={{
          width: '480',
          height: '130',
        }}
        desktop={{
          width: '618',
          height: '130',
        }}
      />
    ),
  });
const PostBibliography = dynamic(
  () => import('components/PostBibliography'),
  {
    loading: () => (
      <PostBibliographyLoading
        mobile={{
          width: '480',
          height: '64',
        }}
        desktop={{
          width: '618',
          height: '64',
        }}
      />
    ),
  });
const SponsorBox = dynamic(
  () => import('components/SponsorBox'),
  {
    loading: () => (
      <SponsorBoxLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });

const AuthorBox = dynamic(
  () => import('components/AuthorBox'),
  {
    loading: () => (
      <AuthorBoxLoading
        mobile={{
          width: '480',
          height: '300',
        }}
        desktop={{
          width: '618',
          height: '300',
        }}
      />
    ),
  });

const ShareButtons = dynamic(
  () => import('components/ShareButtons'),
  {
    loading: () => (
      <ShareButtonsLoading
        mobile={{
          width: '480',
          height: '40',
        }}
        desktop={{
          width: '110',
          height: '212',
        }}
      />
    ),
  });
const Image = dynamic(() => import('components/Image'));
const SEO = dynamic(() => import('components/SEO'));
const AdManager = dynamic(() => import('components/AdManager'));
const Sidebar = dynamic(() => import('components/Sidebar'));

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const getTargets = (post) => ({
  tags: post?.tags?.map((i) => i.name),
  postId: post.id,
  author: post?.author?.slug,
  authorId: post?.author?.id,
  section: 'single',
});

const SpecialPublic = ({ post, preview, fbp }) => {
  const isAmp = useAmp();

  Sentry.addBreadcrumb({
    category: 'screens/SpecialPublic',
    message: `Render special-public ${post?.link}`,
    level: Sentry.Severity.Debug,
  });

  useEffect(() => {
    if (fbp && isBrowser()) {
      const fbPixel = get(publicRuntimeConfig, 'settings.metrics', [publicRuntimeConfig.FACEBOOK_PIXEL_ID]);
      const tags = post?.tags?.map((v) => v.name);

      fbPixel.filter((v) => (!v.name || v.name === 'fbPixel') && v.events).map((v) => {
        fbp.trackSingleCustom(v.codeId,
          'ViewMSContent', {
            content_cat7: post.categories && post.categories.length
              ? post.categories[0].name
              : '',
            content_tags: tags && tags.length ? tags : [],
          });
      });
    }
  }, [post, fbp]);

  const divStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(55, 72, 88, 0) 0%, #374858 130%), url(${post?.featured_media['big-size']})`
  };

  return (
    <PageWrapper config={{ title: post.metas?.title, bodyClasses: 'publi__special' }}>
      <SEO resource={post} />
      <PostCardAdInfo
        logo={post?.sponsor?.logo}
        bgColor={post?.sponsor?.background}
        borderColor={post?.sponsor?.color}
        fontColor={post?.sponsor?.color}
        clientName={post?.sponsor?.brand}
        adType={post?.sponsor?.type}
        changePosition
      />
      <div style={divStyle} className="hero padding-bottom-big">
        <Heading type="h1" textColor="white" size="x-big" className="single-title align-center padding-normal">
          {post?.title}
        </Heading>
        <Breadcrumbs breadcrumbs={post.breadcrumbs || []} className="font-small" />
      </div>
      <Container fluid wrap className="container-single">
        <main id="site-main">
          <div className="row">
            <div className="col-xs-12 col-md-8 col-md-offset-2">

              <div id="single" className="single-post">
                <div id="main-post" className="main-post">
                  <PostMetas post={post} />

                  {post?.author && (
                    <AuthorSignedCard
                      author={post.author}
                      reviewed_by={post.reviewed_by}
                    />
                  )}

                  {post?.headline && (
                    <blockquote
                      dangerouslySetInnerHTML={{
                        __html: post.headline,
                      }}
                    />
                  )}

                  <div className="single-featured-image">
                    <Image src={post?.featured_media} alt={post.title} />
                  </div>

                  {!preview && (
                    <AdManager
                      type="box"
                      display={{
                        desktop: post?.options?.ads === 'on',
                        tablet: post?.options?.ads === 'on',
                        mobile: post?.options?.ads === 'on',
                      }}
                      targets={getTargets(post)}
                    />
                  )}

                  <PostRelatedLinks related_links={post?.related_links} />

                  <div className="the-content">
                    <RenderHtmlReact
                      text={post.content}
                      post={post}
                      preview={preview}
                    />
                  </div>

                  {post?.bibliography
                  && <PostBibliography bibliography={post?.bibliography} />}
                  {(post?.options?.is_sponsored && post?.options?.sponsor)
                  && <SponsorBox sponsor={post?.options?.sponsor} />}
                  {post?.options?.author === 'on' && post?.author
                  && <AuthorBox author={post.author} />}
                </div>
                <ShareButtons post={post} showIn="main-post" />
                {!preview && post?.options?.author === 'on' && post?.author && (
                  // Only show this ad-unit when special-public has an AuthorBox
                  <AdManager
                    type="box"
                    display={{
                      desktop: post?.options?.ads === 'on',
                      tablet: post?.options?.ads === 'on',
                      mobile: post?.options?.ads === 'on',
                    }}
                    targets={getTargets(post)}
                  />
                )}
                <Sidebar
                  sidebarSlug="single-lower-sidebar"
                  preview={preview}
                  ads={{
                    enabled: post?.options?.ads === 'on',
                    targets: getTargets(post),
                  }}
                />
              </div>
            </div>
          </div>
        </main>
      </Container>
      { post?.options?.ads === 'on' && isAmp && (
        <amp-sticky-ad layout="nodisplay" className={'mc-sticky'}>
          <amp-ad
            data-block-on-consent="_till_responded"
            data-enable-refresh="120"
            width="320"
            height="100"
            type="doubleclick"
            data-npa-on-unknown-consent="true"
            data-force-safeframe="true"
            data-slot={`${publicRuntimeConfig.AD_UNIT_ID}`}
            data-multi-size="300x100,320x50,320x100"
            // Disable multi-size validation, more details on:
            // https://github.com/ampproject/amphtml/blob/master/extensions/amp-ad-network-doubleclick-impl/multi-size.md
            data-multi-size-validation="false"
            json={JSON.stringify({
              targeting: {
                tags: post?.tags?.map((i) => i.name),
                postId: post.id,
                author: post?.author?.slug,
                authorId: post?.author?.id,
                section: 'single',
                type: 'sticky',
                position: '1',
                adOrder: 'amp_1',
                source: 'google',
                medium: 'organic',
                locale: publicRuntimeConfig.APP_LOCALE,
                env: 'amp',
                userChannel: 'amp',
                ms: '300x100,320x50,320x100',
                vertical: publicRuntimeConfig.analytics_datasource,
                domain: getSiteDomain(publicRuntimeConfig.wp_site_url),
                tenant: getSiteDomain(publicRuntimeConfig.wp_site_url),
              },
            })}
          >
          </amp-ad>
          <style jsx global>
            {`
                .mc-sticky {
                  z-index: 9999
                }
            `}
          </style>
        </amp-sticky-ad>
      )}
    </PageWrapper>
  );
};

SpecialPublic.propTypes = {
  post: PropTypes.object,
  preview: PropTypes.bool,
  fbp: PropTypes.object,
};

export default SpecialPublic;
